import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
export var LocalStorage = /*#__PURE__*/function () {
  function LocalStorage() {
    _classCallCheck(this, LocalStorage);
  }

  _createClass(LocalStorage, [{
    key: "get",
    value: function get(key) {
      try {
        // localStorage strangely type-casts non-existing data to "null"...
        // Cast it back to undefined if it doesnt exist
        return localStorage.getItem(key) || undefined;
      } catch (err) {
        // Error is ignored
        return '';
      }
    }
  }, {
    key: "set",
    value: function set(key, value) {
      try {
        if (value === undefined || value === null) return this.remove(key);
        return localStorage.setItem(key, value);
      } catch (err) {// Error is ignored
      }
    }
  }, {
    key: "remove",
    value: function remove(key) {
      try {
        localStorage.removeItem(key);
      } catch (err) {// Error is ignored
      }
    }
  }]);

  return LocalStorage;
}();